module.exports = __webpack_public_path__ + "static/media/statement-color.f9d264ec.png";